import PressureGraph from './PressureGraph';
export default PressureGraph;



// WEBPACK FOOTER //
// ./resources/assets/js/containers/PressureGraph/index.js